export default __webpack_public_path__ + "offline.svg";